<template>
  <!-- 产能趋势 -->
  <div class="capacity">

    <table class="mytable">
      <thead>
        <tr>
          <th style="width:10%;">名称/月份</th>
          <th v-for="(mon,index) in 12" :key="index">{{index+1}}月</th>
          <th>
            <i  @click="addRow" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
          </th>
        </tr>
      </thead>
      <tbody>
 
        <tr v-for="(item,i) in tableData" :key='i'>
          <td>
            <el-input v-model="item.proName" placeholder="请输入产品名称"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.oneData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.twoData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.threeData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.fourData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.fiveData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.sixData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.sevenData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.eightData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.nineData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.tenData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.elevenData" placeholder="请输入内容"></el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.twelveData" placeholder="请输入内容"></el-input>
          </td>

          <td style="width: 6rem; text-align:center">
            <i @click="del(item, i)" class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>
          </td>
        </tr>

      </tbody>
    </table>
    <p v-if="!tableData.length" style="text-align: center;margin-top: 5rem;">暂无数据</p>

    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/produce/capacity'
export default {
  components: {},
  data() {
    return {
      tableData: [],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    addRow() {
      this.tableData.push({
        proName: '',
        oneData: '',
        twoData: '',
        threeData: '',
        fourData: '',
        fiveData: '',
        sixData: '',
        sevenData: '',
        eightData: '',
        nineData: '',
        tenData: '',
        elevenData: '',
        twelveData: '',
      })
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {

              this.tableData = res.data.list
            
          } else {
            this.$message.error(res.message)
          }
        })
    },
    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.capacity { padding-top:10px;
  width: 70%;
}
</style>